import React from "react";

export default function Features() {
  return (
    <section id="features" className="section">
      <div className="container">
        <h2 className="title is-2">Fonctionnalités</h2>

        <div
          className="columns"
          style={{
            flexWrap: "wrap",
          }}
        >
          <div className="column is-full-mobile" style={{ display: "flex" }}>
            <img src="./images/food-plate.svg" alt="" />
          </div>

          <div className="column">
            <Feature
              icon="fa fa-barcode"
              color="info"
              title="Scan de produits"
              description="Capturez le code-barres d'un produit et retrouvez toutes ses
              informations nutritionnelles."
            />

            <Feature
              icon="fa fa-utensils"
              color="success"
              title="Suivi nutritionnel"
              description="Ajoutez facilement des produits à votre consommation et obtenez leurs apport caloriques."
            />

            <Feature
              icon="fa fa-history"
              color="warning"
              title="Historique"
              description="Retrouvez à tout moment vos produits scannés et consommés."
            />

            <Feature
              icon="fa fa-user"
              color="danger"
              title="Partout avec vous"
              description="Profitez de toutes les fonctionnalités de Yakoi à l'aide de votre compte et retrouvez vos données sur tous vos appareils."
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Feature({ icon, color, title, description }) {
  return (
    <div className="box">
      <article className="media">
        <div className="media-left">
          <span className={"icon is-large has-text-" + color}>
            <i className={icon + " fa-3x"}></i>
          </span>
        </div>
        <div className="media-content">
          <div className="content">
            <h3 className="has-text-primary is-marginless">{title}</h3>
            <p>{description}</p>
          </div>
        </div>
      </article>
    </div>
  );
}
